import { render, staticRenderFns } from "./invoice-address.vue?vue&type=template&id=036bc9f1"
import script from "./invoice-address.vue?vue&type=script&lang=js"
export * from "./invoice-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports